const CircledDropDown = () =>
{
    return(
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.66668 9.99984C1.66668 14.6022 5.39764 18.3332 10 18.3332C14.6024 18.3332 18.3333 14.6022 18.3333 9.99984C18.3333 5.39746 14.6024 1.6665 10 1.6665C5.39764 1.6665 1.66668 5.39746 1.66668 9.99984Z" stroke="#2F3237" strokeWidth="1.5"/>
<path d="M13.3333 8.75C13.3333 8.75 10.8783 11.25 10 11.25C9.12159 11.25 6.66668 8.75 6.66668 8.75" stroke="#2F3237" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>

    )
}

export default CircledDropDown;